import React, { useContext } from 'react';
// import { useParams } from 'react-router';

import styled from '@emotion/styled';

import useDirectLookupRehireDriver from '../../../../hooks/dashboard/driver-lookup/useDirectLookupRehireDriver';
// import useGetDriverLookup from '../../../../hooks/dashboard/driver-lookup/useGetDriverLookup';
// import { DRIVER_LOOKUP_INFO } from '../../../../routes/routeConstants';
import { FormSubmitButton } from '../../../Button/FormSubmitButton';
import { TranslatingContainerContext } from '../../../TranslatingContainer/TranslatingContainerProvider';
import { ModalContext } from '../../ModalContext';
import { TableContext } from '../../../Table/TableContext';

interface ConfirmCreateDispatcherProps {
  dispatcherData: any;
}

const ConfirmCreateDispatcher: React.FC<ConfirmCreateDispatcherProps> = ({
  dispatcherData,
}) => {
  // const { ninNumber } = useParams();
  const modalContext = useContext(ModalContext);
  const tableContext = useContext(TableContext);

  // const { getDriverLookup } = useGetDriverLookup();
  const { sliderIndex, setSliderIndexPos } = useContext(
    TranslatingContainerContext,
  )!;
  const { rehireDriver, loading } = useDirectLookupRehireDriver();

  const onSubmit = () => {
    rehireDriver(dispatcherData, () => {
      modalContext?.setShowSuccessComponent(true);
      tableContext?.setRefreshTable(!tableContext.refreshTable);
      // getDriverLookup(ninNumber, DRIVER_LOOKUP_INFO, () => {});
    });
  };

  const handleBackToPrevious = () => {
    setSliderIndexPos(-1);
  };

  return (
    <Container className={sliderIndex > 0 ? '' : 'inactive'}>
      <Flex>
        <Description>
          Are you sure you want to rehire{' '}
          <span>
            {dispatcherData?.firstName} {dispatcherData?.lastName}
          </span>
          ?
        </Description>

        <ButtonArea>
          <FormSubmitButton
            className='clear fill text-red'
            onClick={handleBackToPrevious}
            btnType='button'
          >
            Back
          </FormSubmitButton>
          <FormSubmitButton
            btnType='button'
            onClick={onSubmit}
            className='fill'
            loading={loading}
          >
            Approve
          </FormSubmitButton>
        </ButtonArea>
      </Flex>
    </Container>
  );
};

export default ConfirmCreateDispatcher;

const Container = styled.div`
  display: flex;
  /* height: 0px; */

  &.inactive > * {
    display: none;
  }
`;

const ButtonArea = styled.div`
  display: flex;
  width: 100%;
  gap: 16px;
  /* margin-left: auto; */
`;

const Flex = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 36px;
`;

const Description = styled.div`
  font-size: 14px;
  line-height: 20px;
  color: ${({ theme }) => theme.palette.grayTextColor};

  & > span {
    font-weight: 600;
  }
`;
